const cocktailData = [
  {
    name: "Manhattan",
    // abv: "24",
    // volume: "3",
    category: "cocktail",
    mixType: "Stirred",
    serveType: "Up",
    ingredients: [
      {
        name: "James E. Pepper Rye",
        volume: "2",
        abv: 50,
        category: "whiskey",
        hex: "9E4200",
      },
      {
        name: "Carpano Antica Sweet Vermouth",
        volume: "1",
        abv: 16.5,
        category: "vermouth",
        hex: "891576",
      },
      {
        name: "Angostura bitters",
        volume: "0.0625",
        abv: 44.7,
        category: "bitters",
        hex: "AD0E0E",
      },
    ],
  },
  {
    name: "Negroni",
    // abv: "24",
    // volume: "3",
    category: "cocktail",
    mixType: "Stirred",
    serveType: "On the rocks",
    ingredients: [
      {
        name: "Carpano Antica Sweet Vermouth",
        volume: "1",
        abv: 16.5,
        category: "vermouth",
        hex: "891576",
      },
      {
        name: "Campari",
        volume: "1",
        abv: 24,
        category: "amaro, liqueur, aperitif",
        hex: "F57C7C",
      },
      {
        name: "Tanqueray London Dry Gin",
        volume: "1",
        abv: 47.3,
        category: "gin",
        hex: "F1F2F2",
      },
    ],
  },
  {
    name: "Aperol Spritz",
    // abv: "24",
    // volume: "3",
    category: "cocktail",
    mixType: "Built in glass",
    serveType: "On the rocks",
    ingredients: [
      {
        name: "Club soda",
        volume: "1",
        abv: 0,
        category: "Nonalcoholic",
        hex: "D0E7EE",
      },
      {
        name: "Valdo Marca Oro Prosecco",
        volume: "3",
        abv: 11,
        category: "sparkling wine",
        hex: "F5E29D",
      },
      {
        name: "Aperol",
        volume: "1.5",
        abv: 11,
        category: "amaro, liqueur, aperitif",
        hex: "F57C7C",
      },
    ],
  },
  {
    name: "Mojito",
    // abv: "24",
    // volume: "3",
    category: "cocktail",
    mixType: "Stirred",
    serveType: "Crushed ice",
    ingredients: [
      {
        name: "lime juice",
        volume: "1",
        abv: 0,
        category: "Nonalcoholic",
        hex: "A7CE95",
      },
      {
        name: "El Dorado 3 Year Old Rum",
        volume: "2",
        abv: 40,
        category: "rum",
        hex: "9E4200",
      },
      {
        name: "club soda",
        volume: "1",
        abv: 0,
        category: "Nonalcoholic",
        hex: "D0E7EE",
      },
    ],
  },
  {
    name: "Margarita",
    // abv: "24",
    // volume: "3",
    category: "cocktail",
    mixType: "Shaken",
    serveType: "On the rocks",
    ingredients: [
      {
        name: "lime juice",
        volume: "1",
        abv: 0,
        category: "Nonalcoholic",
        hex: "A7CE95",
      },
      {
        name: "Arette Suave Artesanal Blanco Tequila",
        volume: "2",
        abv: 40,
        category: "tequila",
        hex: "D6EDC7",
      },
      {
        name: "Cointreau",
        volume: "1",
        abv: 40,
        category: "amaro, liqueur, aperitif",
        hex: "F57C7C",
      },
    ],
  },
  {
    name: "Whiskey Sour",
    // abv: "24",
    // volume: "3",
    category: "cocktail",
    mixType: "Shaken",
    serveType: "On the rocks",
    ingredients: [
      {
        name: "lemon juice",
        volume: "0.75",
        abv: 0,
        category: "Nonalcoholic",
        hex: "F0DA89",
      },
      {
        name: "Four Roses Bourbon Whiskey",
        volume: "2",
        abv: 40,
        category: "whiskey",
        hex: "9E4200",
      },
      {
        name: "simple syrup",
        volume: "0.75",
        abv: 0,
        category: "Nonalcoholic",
        hex: "D0E7EE",
      },
    ],
  },
  {
    name: "Martini",
    // abv: "24",
    // volume: "3",
    category: "cocktail",
    mixType: "Stirred",
    serveType: "Up",
    ingredients: [
      {
        name: "Beefeater London Dry Gin",
        volume: "2.5",
        abv: 44,
        category: "gin",
        hex: "F1F2F2",
      },
      {
        name: "Noilly Prat Dry vermouth",
        volume: "0.5",
        abv: 18,
        category: "vermouth",
        hex: "891576",
      },
    ],
  },
  {
    name: "Cosmopolitan",
    // abv: "24",
    // volume: "3",
    category: "cocktail",
    mixType: "Shaken",
    serveType: "Up",
    ingredients: [
      {
        name: "Absolut Citron vodka",
        volume: "1.25",
        abv: 40,
        category: "vodka",
        hex: "F1F2F2",
      },
      {
        name: "Rose's sweetened lime juice",
        volume: "0.25",
        abv: 0,
        category: "nonalcoholic",
        hex: "A7CE95",
      },
      {
        name: "Cointreau",
        volume: "0.25",
        abv: 40,
        category: "amaro, liqueur, aperitif",
        hex: "F57C7C",
      },
      {
        name: "Cranberry juice",
        volume: "2",
        abv: 0,
        category: "nonalcoholic",
        hex: "D54333",
      },
    ],
  },
  {
    name: "Daiquiri",
    // abv: "24",
    // volume: "3",
    category: "cocktail",
    mixType: "Shaken",
    serveType: "Up",
    ingredients: [
      {
        name: "El Dorado 3 Year Old Rum",
        volume: "2",
        abv: 40,
        category: "rum",
        hex: "9E4200",
      },
      {
        name: "lime juice",
        volume: "1.166667",
        abv: 0,
        category: "nonalcoholic",
        hex: "A7CE95",
      },
      {
        name: "simple syrup",
        volume: "0.5",
        abv: 0,
        category: "nonalcoholic",
        hex: "D0E7EE",
      },
    ],
  },
  {
    name: "French 75",
    // abv: "24",
    // volume: "3",
    category: "cocktail",
    mixType: "Shaken",
    serveType: "Up",
    ingredients: [
      {
        name: "Plymouth gin",
        volume: "1.5",
        abv: 41.2,
        category: "gin",
        hex: "F1F2F2",
      },
      {
        name: "lemon juice",
        volume: "0.75",
        abv: 0,
        category: "nonalcoholic",
        hex: "F0DA89",
      },
      {
        name: "simple syrup",
        volume: "0.5",
        abv: 0,
        category: "nonalcoholic",
        hex: "D0E7EE",
      },
      {
        name: "Roederer Estate Brut Sparkling Wine",
        volume: "2",
        abv: 12.5,
        category: "sparkling wine",
        hex: "F5E29D",
      },
    ],
  },
  {
    name: "Moscow Mule",
    // abv: "24",
    // volume: "3",
    category: "cocktail",
    mixType: "Built in glass",
    serveType: "Crushed ice",
    ingredients: [
      {
        name: "lime juice",
        volume: "0.5",
        abv: 0,
        category: "Nonalcoholic",
        hex: "A7CE95",
      },
      {
        name: "Reyka Vodka",
        volume: "2",
        abv: 40,
        category: "vodka",
        hex: "F1F2F2",
      },
      {
        name: "ginger beer",
        volume: "5",
        abv: 0,
        category: "Nonalcoholic",
        hex: "F2CFA4",
      },
    ],
  },
  {
    name: "Gin and Tonic",
    // abv: "24",
    // volume: "3",
    category: "cocktail",
    mixType: "Built in glass",
    serveType: "On the rocks",
    ingredients: [
      {
        name: "Tonic water",
        volume: "6.8",
        abv: 0,
        category: "Nonalcoholic",
        hex: "D0E7EE",
      },
      {
        name: "Sipsmith Gin",
        volume: "2",
        abv: 41.6,
        category: "gin",
        hex: "F1F2F2",
      },
    ],
  },
]

export default cocktailData
